var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "permission"
  }, [_c('div', {
    staticClass: "text-2xl font-bold mb-6"
  }, [_vm._v("Permission")]), _c('div', {
    staticClass: "border shadow-lg rounded-md bg-white"
  }, [_c('div', {
    staticClass: "p-6 flex justify-between"
  }, [_c('div', {
    staticClass: "flex items-center gap-4"
  }, [_c('div', {
    staticClass: "w-60"
  }, [_c('TextField', {
    attrs: {
      "type": "text",
      "action": _vm.doSearch,
      "placeholder": "Masukan kata kunci"
    },
    model: {
      value: _vm.searchTerm,
      callback: function ($$v) {
        _vm.searchTerm = $$v;
      },
      expression: "searchTerm"
    }
  })], 1), _c('div', {}, [_c('Button', {
    attrs: {
      "buttonText": "Cari"
    },
    on: {
      "action": function ($event) {
        return _vm.doSearch();
      }
    }
  })], 1)])]), _c('TableComponent', {
    scopedSlots: _vm._u([{
      key: "header",
      fn: function () {
        return [_c('td', {
          staticClass: "w-16 text-center"
        }, [_vm._v("No.")]), _c('td', {
          staticClass: "w-96"
        }, [_vm._v("id")]), _c('td', {
          staticClass: "w-96"
        }, [_vm._v("Description")])];
      },
      proxy: true
    }, {
      key: "body",
      fn: function () {
        return [_vm.filteredData && _vm.filteredData.length > 0 ? _vm._l(_vm.filteredData, function (item, index) {
          return _c('tr', {
            key: item.code
          }, [_c('td', {
            staticClass: "w-16 text-center"
          }, [_vm._v(_vm._s((_vm.currentPage - 1) * _vm.perPage + (index + 1)))]), _c('td', {
            staticClass: "w-96"
          }, [_vm._v(_vm._s(item.id))]), _c('td', {
            staticClass: "w-96"
          }, [_vm._v(_vm._s(item.description))])]);
        }) : [_c('tr', [_c('td', {
          staticClass: "text-center",
          attrs: {
            "colspan": "5"
          }
        }, [_c('div', {
          staticClass: "py-6"
        }, [_vm._v("Tidak ada data yang tersedia.")])])])]];
      },
      proxy: true
    }])
  })], 1)]);

}
var staticRenderFns = []

export { render, staticRenderFns }